import { Button, IconButton } from "@material-ui/core"
import { SingleServiceCenter } from "api"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import { trackPopUpOpen } from "common/analytics"
import { useEffect, useRef, useState } from "react"
import BackButton from "reusable/BackButton"
import InnerPageWrapper from "reusable/wrappers/InnerPageWrapper"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"
import CenterGallery from "./aboutUs/CenterGallery"
import CenterServices from "./aboutUs/CenterServices"
import CenterBenefits from "./benefits/CenterBenefits"
import ContentUsPopup from "./popups/ContentUsPopup"
import TreatmentPopup from "./popups/TreatmentPopup"
import CenterProfile from "./profile/CenterProfile"

const StyledContentWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
  position: relative;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 5px;
    gap: 5px;
  }
`
const StyledWhiteWrapper = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin: 0 -20px;
    padding: 30px 20px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 30px;
    border-radius: 10px;
  }
`

const StyledIconButton = styled(IconButton)`
  &:hover {
    background: none;
  }
  width: 100px;
  height: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: right;
  }
  svg {
    margin-top: 2px;
  }
`

const StyledCenterData = styled.div<{ $showLess: boolean }>`
  overflow: ${(p) => (p.$showLess ? "auto" : "hidden")};
  text-overflow: ellipsis;
  display: -webkit-box;
  ${(p) => !p.$showLess && "-webkit-line-clamp: 3"};
  -webkit-box-orient: vertical;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #101010;
`

const StyledShowMoreBtn = styled(Button)`
  background: no-repeat;
  border: none;
  font-size: 18px;
  color: #4c607e;
  text-decoration: underline;
  justify-content: right;
  padding: 0px;
  margin-bottom: 40px;
  &:hover {
    background: none;
    outline: none;
    border: none;
    color: #4c607e;
    text-decoration: underline;
  }
`

type SingleServiceCenterPageProps = {
  centerData: SingleServiceCenter
}

const SingleServiceCenterPage = ({
  centerData,
}: SingleServiceCenterPageProps) => {
  const [openContentUs, setOpenContentUsPopup] = useState(false)
  const [openTreatment, setOpenTreatment] = useState(false)
  const isDesktop = useIsDesktop()
  const containerRef = useRef(null)
  const [showMore, setShowMore] = useState(false)
  const [showLess, setShowLess] = useState(false)

  useEffect(() => {
    if (
      containerRef &&
      containerRef.current &&
      containerRef.current.scrollHeight > containerRef.current.clientHeight
    ) {
      setShowMore(true)
    }
  }, [])

  return (
    <InnerPageWrapper
      imgUrl={
        centerData?.imagePath
          ? centerData?.imagePath
          : isDesktop
          ? "/img/cover/Servicecenters.jpg"
          : "/img/cover/Servicecentersmobile.jpg"
      }
    >
      <StyledContentWrap>
        <BreadCrumbsWrapper name={"ServicesCenters"} page={"singleService"} />
        <StyledIconButton role="link">
          <BackButton />
        </StyledIconButton>
        <StyledWhiteWrapper>
          <CenterProfile
            centerData={centerData}
            openTreatmentFunc={() => {
              setOpenTreatment(true)
              trackPopUpOpen("קביעת ביקור")
            }}
            openContentUsFunc={() => {
              setOpenContentUsPopup(true)
              trackPopUpOpen("יצירת קשר")
            }}
          />
        </StyledWhiteWrapper>
        {/* benefits */}
        <StyledWhiteWrapper>
          <CenterBenefits centerBenefits={centerData.benefits} />
        </StyledWhiteWrapper>
        {/* a little about us */}
        <StyledWhiteWrapper>
          <div>
            <TypographyRtl
              $mb="20px"
              variant="h2"
              $fontSize="20px"
              $fontWeight="300"
            >
              אודות מרכז השירות
            </TypographyRtl>
            {centerData.description && (
              <>
                <StyledCenterData
                  ref={containerRef}
                  $showLess={showLess}
                  dangerouslySetInnerHTML={{ __html: centerData.description }}
                />

                {showMore && (
                  <StyledShowMoreBtn
                    onClick={() => {
                      setShowMore(false)
                      setShowLess(true)
                    }}
                  >
                    קרא עוד
                  </StyledShowMoreBtn>
                )}
                {showLess && (
                  <StyledShowMoreBtn
                    onClick={() => {
                      setShowMore(true)
                      setShowLess(false)
                    }}
                  >
                    קרא פחות
                  </StyledShowMoreBtn>
                )}
              </>
            )}
          </div>
          <CenterServices data={centerData?.services} />
          <CenterGallery serviceCenter={centerData} />
        </StyledWhiteWrapper>
      </StyledContentWrap>
      <ContentUsPopup
        centerData={centerData}
        open={openContentUs}
        onClose={() => setOpenContentUsPopup(false)}
      />
      <TreatmentPopup
        centerData={centerData}
        open={openTreatment}
        onClose={() => setOpenTreatment(false)}
      />
    </InnerPageWrapper>
  )
}

export default SingleServiceCenterPage
